var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoalcomp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 18,
    fill: "#F2FFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6929 43.1319C28.6027 43.1319 28.5135 43.1132 28.4309 43.0771C28.3482 43.0409 28.274 42.9881 28.2128 42.9218L15.2675 28.9187C15.1812 28.8254 15.124 28.7089 15.1028 28.5835C15.0817 28.4582 15.0976 28.3294 15.1485 28.2129C15.1995 28.0964 15.2833 27.9973 15.3897 27.9277C15.4961 27.8581 15.6205 27.8211 15.7476 27.8211H21.9787C22.0723 27.8211 22.1648 27.8412 22.2499 27.88C22.335 27.9187 22.4109 27.9753 22.4723 28.0459L26.7986 33.0233C27.2662 32.0238 28.1713 30.3596 29.7596 28.3318C32.1077 25.3339 36.4753 20.925 43.9477 16.9449C44.0921 16.868 44.2602 16.848 44.4186 16.8889C44.577 16.9298 44.7143 17.0287 44.8034 17.1659C44.8925 17.3032 44.9269 17.4688 44.8999 17.6302C44.8728 17.7916 44.7862 17.9369 44.6571 18.0376C44.6286 18.0599 41.7475 20.3287 38.4317 24.4845C35.3801 28.3088 31.3235 34.5622 29.3274 42.6353C29.2923 42.7771 29.2108 42.9031 29.0957 42.9932C28.9807 43.0832 28.8388 43.1322 28.6927 43.1322L28.6929 43.1319Z",
    fill: "#43BC33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalcomp);
export default __webpack_public_path__ + "static/media/goalcomp.ba2464e28936a451f19423054d7fb84a.svg";
export { ForwardRef as ReactComponent };